<template>
  <div class="page">
    <div class="page-header">
      <Back @click="$router.back()"/>
      <span>
        Checkin Wisuda
      </span>
    </div>

    <div class="body">
      <div>
        <div class="grid">
          <div class="card">
            <h3>{{ summary.jumlah_checkin }}</h3>
            <p>Jumlah Checkin</p>
          </div>
          <div class="card">
            <h3>{{ summary.jumlah_peserta }}</h3>
            <p>Jumlah Peserta</p>
          </div>
        </div>

        <div v-show="loadingScan">
          <Loading />
        </div>

        <div class="form" v-show="siswa.id_siswa">
          <table>
            <tr>
              <td>Kode Booking</td>
              <td>:</td>
              <td>{{ siswa.no_booking }}</td>
            </tr>
            <tr>
              <td>No Kursi</td>
              <td>:</td>
              <td>{{ siswa.no_kursi }}</td>
            </tr>
            <tr>
              <td>Nama</td>
              <td>:</td>
              <td>{{ siswa.nama_lengkap }}</td>
            </tr>
            <tr>
              <td>No Daftar</td>
              <td>:</td>
              <td>{{ siswa.no_daftar }}</td>
            </tr>
            <tr>
              <td>Angkatan</td>
              <td>:</td>
              <td>{{ siswa.angkatan_2 }}</td>
            </tr>
            <tr>
              <td>Kampus</td>
              <td>:</td>
              <td>{{ siswa.kampus }}</td>
            </tr>
            <tr>
              <td>Jurusan</td>
              <td>:</td>
              <td>{{ siswa.jurusan }}</td>
            </tr>
            <tr>
              <td>Pendamping</td>
              <td>:</td>
              <td>{{ siswa.nama_pendamping_1 || "-" }}</td>
            </tr>
          </table>
          <button @click="cetak">Cetak Struk</button>
        </div>
      </div>

      <div class="btn-scan">
        <div class="btn-group">
          <button @click="scan()" :disabled="loadingScan">
            {{ loadingScan ? "Validating data.." : "Scan QRCode" }}
          </button>
          <button @click="openModal()">Cari</button>
        </div>
      </div>
    </div>

    <div class="overlay" @click="closeModal" v-show="modalOpen"></div>
    <div class="modal" v-show="modalOpen">
      <div class="modal-body">
        <form @submit.prevent="cari">
          <input
            type="search"
            placeholder="Cari Nama / No Daftar"
            ref="input_cari"
            v-model="keyword"
          />
        </form>

        <div class="loading" v-show="loadingSearching">
          <Loading />
        </div>
        <ul v-show="!loadingSearching">
          <li
            v-for="(item, index) in data"
            :key="index"
            @click="ambil(item.no_booking)"
          >
            <div>
              <small>{{ item.no_daftar }}</small>
              <p>{{ item.nama_lengkap }}</p>
              <span>{{ item.jurusan }}</span>
            </div>
            <div>
              <small>{{ item.angkatan }}</small>
              <p style="font-weight: 500">{{ item.kampus }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../api";
import moment from "moment";
import Back from "./../assets/Back.vue";
import Loading from '../assets/Loading.vue';

export default {
  name: "app",
  components: {
    Back,
    Loading,
  },
  data() {
    return {
      loadingSearching: false,
      loadingScan: false,
      siswa: {},
      wisuda: {},
      data: [],
      summary: {},
      modalOpen: false,
      keyword: "",
    };
  },
  methods: {
    scan() {
      setTimeout(() => {
        cordova.plugins.barcodeScanner.scan(
          (result) => {
            this.kodeBooking = result.text;
            this.ambil(this.kodeBooking);
          },
          (error) => {
            alert("Scanning failed: " + error);
          }
        );
      }, 150);
    },
    ambil(noBooking) {
      this.closeModal();

      const siswa = this.$store.state.peserta.data.find((k) => {
        return k.no_booking == noBooking;
      });
      if (siswa) {
        this.siswa = siswa;
      } else {
        alert("Data tidak ditemukan");
      }

      // api
      //   .get("/v1/wisuda/CheckinController/getSiswa?no_booking=" + noBooking)
      //   .then((r) => {
      //     this.loadingScan = false;
      //     if (r.valid) {
      //       this.siswa = r.siswa;
      //       // this.wisuda = r.data.pendaftar;
      //     } else {
      //       alert(r.message);
      //     }
      //   })
      //   .catch((e) => {
      //     this.loadingScan = false;
      //     alert("Server error");
      //   });
    },
    cari() {
      this.loadingSearching = true;
      this.data = this.$store.state.peserta.data.filter((k) => {
        return (
          k.no_daftar == this.keyword ||
          k.nama_lengkap.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1
        );
      });

      // api
      //   .get("/v1/SiswaController/search?keyword=" + this.keyword)
      //   .then((r) => {
      //     this.loadingSearching = false;

      //     if (r.valid) {
      //       this.data = r.data;
      //     } else {
      //       alert(r.message);
      //     }
      //   })
      //   .catch((e) => {
      //     this.loadingSearching = false;
      //     alert("Error: " + e.message);
      //   });
    },
    cetak() {
      const login = JSON.parse(localStorage.getItem("login"));

      api
        .postJson("/v1/wisuda/CheckinController/checkin", {
          id: this.siswa.id_wisuda,
          id_user: login.id,
        })
        .then((r) => {
          this.load();

          var esc = "\x1B";
          var printer_helper = {
            lebar_kertas: 32,

            init: esc + "@",
            font_bold: esc + "!" + "\x21\x01",
            font_double_size: esc + "!" + "\x38",
            font_small_size: esc + "!" + "\x01",
            font_normal: esc + "!" + "\x02",
            reset_font: esc + "!" + "\x00",

            garis: function (val) {
              var g = "";
              for (var i = 0; i < printer_helper.lebar_kertas; i++) {
                g += val;
              }
              return g;
            },
          };

          if (r.valid) {
            // Cetak
            var text = printer_helper.init;

            if (this.siswa.nama_pendamping_1) {
              text += printer_helper.font_bold + "CHECKIN WISUDA" + "\n";
              text +=
                printer_helper.font_small_size + "Untuk Pendamping" + "\n\n";
              text += printer_helper.font_normal;

              text +=
                "NAMA     : " + this.siswa.nama_lengkap.toUpperCase() + "\n";
              text += "NO DAFTAR: " + this.siswa.no_daftar + "\n";
              text += "NO KURSI : \n\n";
              text +=
                printer_helper.font_double_size +
                "      " +
                this.siswa.no_kursi.padStart(3, "0") +
                "\n\n";
              text +=
                printer_helper.font_small_size +
                moment().format("DD-MM-YY HH:mm") +
                "\n";
              text +=
                printer_helper.font_normal +
                printer_helper.garis("-") +
                "\n\n\n";

              BTPrinter.printText(
                (data) => {
                  // this.load();
                },
                (err) => {},
                text
              );
            }

            // // RESET
            text = printer_helper.init;
            text += printer_helper.font_bold + "CHECKIN WISUDA" + "\n";
            text += printer_helper.font_small_size + "Untuk Siswa" + "\n\n";
            text += printer_helper.font_normal;

            text +=
              "NAMA     : " + this.siswa.nama_lengkap.toUpperCase() + "\n";
            text += "NO DAFTAR: " + this.siswa.no_daftar + "\n";
            text += "NO KURSI : \n\n";
            text +=
              printer_helper.font_double_size +
              "      " +
              this.siswa.no_kursi.padStart(3, "0") +
              "\n\n";
            text +=
              printer_helper.font_small_size +
              moment().format("DD-MM-YY HH:mm") +
              "\n";
            text +=
              printer_helper.font_normal + printer_helper.garis("-") + "\n";

            // SNACK & SOUVENIR
            text += printer_helper.font_normal;
            text +=
              this.siswa.no_daftar +
              " - " +
              this.siswa.nama_lengkap.toUpperCase() +
              "\n\n";

            if (this.siswa.nama_pendamping_1) {
              text += printer_helper.font_double_size + "    SNACK 2\n";
            } else {
              text += printer_helper.font_double_size + "    SNACK 1\n";
            }

            text +=
              printer_helper.font_normal +
              "\n" +
              printer_helper.garis("-") +
              "\n";

            // SOUVENIR
            text += printer_helper.font_normal;
            text +=
              this.siswa.no_daftar +
              " - " +
              this.siswa.nama_lengkap.toUpperCase() +
              "\n\n";
            text += printer_helper.font_double_size + "    SOUVENIR" + "\n";

            text += "\n\n\n"; //padding-bottom;

            setTimeout(() => {
              BTPrinter.printText(
                (data) => {
                  this.load();
                },
                (err) => {},
                text
              );
            }, 4000);
          } else {
            alert(r.message);
          }
        });
    },
    load() {
      // this.loading = true;
      api
        .get("/v1/wisuda/CheckinController/summaryCheckin")
        .then((r) => {
          // this.loading = false;
          this.summary = r.data;
        })
        .catch((e) => {
          // this.loading = false;
          alert("Gagal mengambil data");
        });
    },
    openModal() {
      this.modalOpen = true;
      this.$refs["input_cari"].focus();
    },
    closeModal() {
      this.modalOpen = false;
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding-top: 80px;

  .form {
    margin-top: 20px;
    table {
      margin-bottom: 15px;
      tr {
        td {
          padding: 3px 0;
          font-size: 14px;
          &:nth-child(2) {
            padding: 0 5px 0 10px;
          }
          &:last-child {
            font-weight: 600;
          }
        }
      }
    }

    .token {
      display: grid;
      grid-template-columns: 1fr 1fr;
      border: 1px solid #333;
      margin-bottom: 20px;
      img {
        width: 100%;
      }
    }
  }

  .body {
    padding-bottom: 60px;

    .grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 15px;
      .card {
        border: 1px solid #999;
        border-radius: 8px;
        padding: 15px;
        h3,
        p {
          border: 0;
          margin: 0;
        }
        p {
          margin-top: 10px;
          font-size: 12px;
        }
      }
    }

    p {
      font-size: 14px;
    }
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #ccc;
        padding: 10px 0;
        p {
          margin: 0;
          margin-top: 4px;
          font-weight: 600;
        }
        small {
          color: #777;
        }
      }
    }
  }

  .btn-scan {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    border-top: 1px solid #ccc;
    .btn-group {
      margin: 20px;
      display: grid;
      grid-template-columns: 1fr 130px;
      grid-column-gap: 15px;
    }
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    width: 100%;
    height: 100%;
  }

  .modal {
    background-color: #fff;
    width: 80%;
    height: 450px;
    position: fixed;
    top: 50px;
    left: 10%;
    .modal-body {
      margin: 20px;
      input {
        border: 1px solid #999;
        padding: 10px;
        width: 100%;
        outline: none;
        &:focus {
          border-color: #333;
        }
      }
      ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        margin-top: 20px;
        display: block;
        overflow: auto;
        height: 350px;
        li {
          border-bottom: 1px solid #ccc;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 5px 0;

          &:active {
            background-color: #eee;
          }

          p {
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
          }
          span {
            font-size: 13px;
          }

          > div {
            &:last-child {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Checkin.vue